import { permissionsAPI } from './permissionsAPI';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

export const getPermissionForRole = createAsyncThunk('service/authority', async (role) => {
  const response = await permissionsAPI.getPermissionsForRole(role);
  return response.data;
});
